import { Select, SelectProps, forwardRef } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import React from 'react';
import { ReactComponent as Arrow } from '../../assets/svgs/dropdown_arrow.svg';
import { rem } from 'utils/fonts';

const StyledSelect = styled(Select)<{ borderless?: boolean }>`
  border: ${(props): string => (props.borderless ? 'none' : `1px solid inherit`)};
  margin-left: ${(props): string => (props.borderless ? '-20px' : '0px')};
  border-radius: 9px;
  font-style: normal;
  font-weight: normal;
  font-size: ${rem(15)};
  line-height: 15px;
  padding: 21px 20px;
  height: 60px;
`;

interface Props extends SelectProps {
  borderless?: boolean;
}

// eslint-disable-next-line react/display-name
const Dropdown = forwardRef<Props, 'select'>(({ children, borderless = false, ...props }, ref) => {
  return (
    <StyledSelect ref={ref} icon={<Arrow />} iconSize="3px" focusBorderColor="pink.500" borderless={borderless} {...props}>
      {children}
    </StyledSelect>
  );
});

export default Dropdown;
